import { useEffect } from 'react';

interface Props {
  callback: () => void;
  cleanup?: () => void;
}

// needed for 2 way binding of url state
export function useHistoryListener({ callback, cleanup }: Props) {
  useEffect(() => {
    addEventListener('popstate', callback);
    addEventListener('pushState', callback);
    addEventListener('replaceState', callback);

    return () => {
      removeEventListener('popstate', callback);
      removeEventListener('pushState', callback);
      removeEventListener('replaceState', callback);
      cleanup && cleanup();
    };
  }, [callback, cleanup]);
}
